<template>
    <div class="row justify-content-center">
        <div class="col-12">
            <form @submit.prevent="generateQr" class="input-group">
                <input
                    v-model="link"
                    type="url"
                    class="form-control py-3 rounded-c-3"
                    autofocus
                    required
                />
                <button
                    type="submit"
                    class="btn btn-lg btn-c-secondary rounded-c-3 px-5 py-4 fs-6 text-white shadow"
                    :class="link ? '' : 'disabled'"
                    :disabled="$store.state.loading"
                >
                    <div
                        class="spinner-grow spinner-grow-sm text-white ms-1"
                        role="status"
                        v-if="$store.state.loading"
                    >
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <span v-else>{{
                        localise("qr_generator", "generate")
                    }}</span>
                </button>
            </form>
            <p
                v-if="generated && !$store.state.loading"
                class="text-center mt-3 mb-0 bg-light border rounded-3 p-4"
            >
                <div class="mb-3">
                    <img width="200" height="200" :src="generated" :alt="generated" />
                </div>
                <a
                    :href="generated"
                    class="btn btn-lg btn-c-primary rounded-c-3 px-5 py-4 fs-6 text-white shadow"
                    download
                >
                    {{ localise("qr_generator", "download") }}
                </a>
            </p>
        </div>
    </div>
</template>

<script>
import { generate } from "../../services/InternalApiService";
import LoadingOverlay from "../others/LoadingOverlay.vue";
import translations from "../../helpers/translations";

export default {
    name: "QrGenerator",
    components: { LoadingOverlay },
    data() {
        return {
            link: "",
            generated: "",
        };
    },
    methods: {
        generateQr() {
            this.$store.state.loading = true;
            generate({ link: this.link })
                .then((res) => {
                    if (res.status === 200) {
                        this.generated = res.data.data;
                        this.$store.state.loading = false;
                    }
                })
                .catch(console.error());
        },
        localise(cat, key) {
            return translations[this.$store.state.locale][cat][key];
        },
    },
};
</script>
